import React from "react";
import { Link } from "react-router-dom";
import { planFeatureText } from "../../utility/planTiers";

const PlanFeatureList = ({ lines, className }) => (
  <ul className={className}>
    {lines.map((line) => {
      const text = planFeatureText(line);
      const key = line && typeof line === "object" && line.to ? line.to : text;
      return (
        <li key={key}>
          {line && typeof line === "object" && line.to ? (
            <Link to={line.to} className="underline text-brand-gold-ink">
              {text}
            </Link>
          ) : (
            text
          )}
        </li>
      );
    })}
  </ul>
);

export default PlanFeatureList;
